import {ApiResult, CrudService} from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {OperadorEstrangeiroVersaoEntity} from '../../models';
import {OPERACAO_API_URL} from "@catalogo/features/compartilhado/const/constantes";
import {EnumTipoAutenticacaoEnvioPortalUnico} from "@catalogo/features/operacional/enums/enum-entities";

@Injectable({providedIn: 'root',})
export class OperadorEstrangeiroVersaoDataService extends CrudService<OperadorEstrangeiroVersaoEntity> {

    protected url: string;

    private urlReplace: string;

    constructor(
        @Inject(OPERACAO_API_URL) public urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.urlReplace = `${urlBase}/v1/operadorestrangeiro/<parent>/versao`;
    }

    public withParentId(id: string) {
        this.url = this.urlReplace.replace('<parent>', id);
        return this;
    }

    public pendenteEnvioPortalUnico() {
        this.url = `${this.urlBase}/v1/operadorestrangeiro/VersoesPendentes`;
        return this;
    }

    public gerarVersoes(listaIds: string[]) {
        const url = `${this.urlBase}/v1/operadorestrangeiro/GerarVersaoLote`;
        return this.httpClient.post<ApiResult<any>>(url, listaIds);
    }

    public gerarVersao(operadorEstrangeiroId: string) {
        const url = `${this.urlBase}/v1/operadorestrangeiro/${operadorEstrangeiroId}/versao`;
        return this.httpClient.post<ApiResult<any>>(url, {});
    }


    public solicitarEnvioPortalUnico(ids: string[], senhaCertificado: string, tipoAutenticacao: EnumTipoAutenticacaoEnvioPortalUnico) {
        return this.httpClient.post<ApiResult<any>>(`${this.urlBase}/v1/operadorestrangeiro/Versao/SolicitarEnvioPortalUnico`, {
            ids,
            senhaCertificado,
            tipoAutenticacao: <EnumTipoAutenticacaoEnvioPortalUnico>tipoAutenticacao
        });
    }

    public atualizarDataReferencia(payload: OperadorEstrangeiroVersaoEntity) {
        const url = `${this.urlBase}/v1/operadorestrangeiro/Versao/${payload.id}/Retroativa`;
        return this.httpClient.put<ApiResult<any>>(url, payload);
    }

    public adicionarVersaoRetificada(payload: OperadorEstrangeiroVersaoEntity) {
        const url = `${this.urlBase}/v1/operadorestrangeiro/Versao/${payload.id}/Retificacao`;
        return this.httpClient.post<ApiResult<any>>(url, payload);
    }

    public inativarVersao(operadorEstrangeiroVersaoId?: string, operadorEstrangeiroVersaoEmpresaId?: string) {
        const url = `${this.urlBase}/v1/operadorestrangeiro/Versao/Inativar`;
        return this.httpClient.put<ApiResult<any>>(url, {
            operadorEstrangeiroVersaoId,
            operadorEstrangeiroVersaoEmpresaId
        });
    }

    public obterVersao(operadorEstrangeiroVersaoId?: string) {
        const url = `${this.urlBase}/v1/operadorestrangeiro/Versao/${operadorEstrangeiroVersaoId}`;
        return this.httpClient.get<ApiResult<OperadorEstrangeiroVersaoEntity>>(url, {})
    }
}
